import React, { useState, useEffect, useRef, useCallback } from 'react'
// import PropTypes from "prop-types";
// import "../../../slider.css";

const RangeSlider = ({ min, max, current, callback, step, valueFormatter, unit, children, className, type }) => {
    const [minVal, setMinVal] = useState(min);
    const [maxVal, setMaxVal] = useState(max);
    const maxValRef = useRef(current);
    const [mouseState, setMouseState] = useState(null);
    // const minValRef = useRef(0);
    const range = useRef(null);
  
    const rangeValueFormatter = useCallback((val) => {
        if(typeof valueFormatter === "function") {
            return valueFormatter(val)
        } else {
            return val
        }
    },[valueFormatter])
  
    const unitFormatter = useCallback(() => {
      if(typeof unit === "string") {
          return unit
      } else {
          return ''
      }
  },[unit])
  
    // Convert to percentage
    const getPercent = useCallback( (value) => {
      return Math.round(((value - min) / (max - min)) * 100)
    },[min, max]);
  
    // Set width of the range to decrease from the left side
    useEffect(() => {
      const minPercent = getPercent(minVal);
      const maxPercent = getPercent(maxVal);
      // console.log({minPercent,maxPercent, width: (maxPercent - minPercent)});
  
      if (range.current) {
        range.current.style.left = `${minPercent}%`;
        range.current.style.width = `${ (maxPercent - minPercent) }%`;
      }
    }, [minVal, getPercent]);
  
    // Set width of the range to decrease from the right side
    useEffect(() => {
      const minPercent = getPercent(minVal);
      const maxPercent = getPercent(maxVal);
  
      if (range.current) {
        range.current.style.width = `${ (maxPercent - minPercent) }%`;
      }
    }, [maxVal, getPercent]);
  
    useEffect(() => {
      if (mouseState === "up") {
        callback( maxVal)
      }
    }, [mouseState])

    useEffect(() => {
      setMaxVal(current);
    }, [current])

  
    return (
      <div className={`range-wrapper${ className ? ' ' + className:''}`}>
        <div className="multi-range-container">
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={maxVal || 0}
            onChange={event => {
              const value = Math.max(Number(event.target.value), minVal );
              setMaxVal(value);
              maxValRef.current = value;
            }}
            onMouseDown={() => setMouseState("down")} // When mouse down set the mouseState to 'down'
            onMouseUp={() => setMouseState("up")} // When mouse down set the mouseState to 'up' | now we can call the parent onChnage
            onTouchStart={() => setMouseState("down")}
            onTouchEnd={() => setMouseState("up")}
            className="thumb thumb--right"
          />
    
          <div className="slider">
            <div className="slider__track" />
            <div ref={range} className="slider__range" />
            { type === 'filter' &&
              <div className="slider__right-value">{ rangeValueFormatter( maxVal) + unitFormatter() }</div>
            }
          </div>
        </div>
        <div className="range-content">
            { type !== 'filter' &&
              <label>{ rangeValueFormatter( maxVal) + unitFormatter() }</label>
            }
            { children }
          </div>
      </div>
    );
};
  
// RangeSliderWIP.propTypes = {
//     min: PropTypes.number.isRequired,
//     max: PropTypes.number.isRequired
// };
  
export default RangeSlider;
  